{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "You have exceeded the conversation limit. Hacker plan allows only 500 conversations.",
      "INBOXES": "You have exceeded the inbox limit. Hacker plan only supports website live-chat. Additional inboxes like email, WhatsApp etc. require a paid plan.",
      "AGENTS": "You have exceeded the agent limit. Your plan only allows {allowedAgents} agents.",
      "NON_ADMIN": "Please contact your administrator to upgrade the plan and continue using all features."
    },
    "TITLE": "Ustawienia konta",
    "SUBMIT": "Zaktualizuj ustawienia",
    "BACK": "Powrót",
    "DISMISS": "Odrzuć",
    "UPDATE": {
      "ERROR": "Nie udało się zaktualizować ustawień, spróbuj ponownie!",
      "SUCCESS": "Ustawienia konta zostały pomyślnie zaktualizowane"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Delete your Account",
      "NOTE": "Once you delete your account, all your data will be deleted.",
      "BUTTON_TEXT": "Delete Your Account",
      "CONFIRM": {
        "TITLE": "Delete Account",
        "MESSAGE": "Deleting your Account is irreversible. Enter your account name below to confirm you want to permanently delete it.",
        "BUTTON_TEXT": "Usuń",
        "DISMISS": "Anuluj",
        "PLACE_HOLDER": "Proszę wpisać {accountName}, aby potwierdzić"
      },
      "SUCCESS": "Account marked for deletion",
      "FAILURE": "Could not delete account, try again!",
      "SCHEDULED_DELETION": {
        "TITLE": "Account Scheduled for Deletion",
        "MESSAGE_MANUAL": "This account is scheduled for deletion on {deletionDate}. This was requested by an administrator. You can cancel the deletion before this date.",
        "MESSAGE_INACTIVITY": "This account is scheduled for deletion on {deletionDate} due to account inactivity. You can cancel the deletion before this date.",
        "CLEAR_BUTTON": "Cancel Scheduled Deletion"
      }
    },
    "FORM": {
      "ERROR": "Proszę poprawić błędy formularza",
      "GENERAL_SECTION": {
        "TITLE": "Ustawienia ogólne",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "ID konta",
        "NOTE": "To ID jest wymagane, jeśli tworzysz integrację opartą na API"
      },
      "AUTO_RESOLVE": {
        "TITLE": "Auto-resolve conversations",
        "NOTE": "This configuration would allow you to automatically resolve the conversation after a certain period of inactivity.",
        "DURATION": {
          "LABEL": "Inactivity duration",
          "HELP": "Time period of inactivity after which conversation is auto-resolved",
          "PLACEHOLDER": "30",
          "ERROR": "Auto resolve duration should be between 10 minutes and 999 days",
          "API": {
            "SUCCESS": "Auto resolve settings updated successfully",
            "ERROR": "Failed to update auto resolve settings"
          }
        },
        "MESSAGE": {
          "LABEL": "Custom auto-resolution message",
          "PLACEHOLDER": "Conversation was marked resolved by system due to 15 days of inactivity",
          "HELP": "Message sent to the customer after conversation is auto-resolved"
        },
        "PREFERENCES": "Preferencje",
        "LABEL": {
          "LABEL": "Add label after auto-resolution",
          "PLACEHOLDER": "Select a label"
        },
        "IGNORE_WAITING": {
          "LABEL": "Skip conversations waiting for agent’s reply"
        },
        "UPDATE_BUTTON": "Save Changes"
      },
      "NAME": {
        "LABEL": "Nazwa konta",
        "PLACEHOLDER": "Nazwa konta",
        "ERROR": "Wprowadź poprawną nazwę konta"
      },
      "LANGUAGE": {
        "LABEL": "Język strony",
        "PLACEHOLDER": "Język konta",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Domena przychodzących wiadomości e-mail",
        "PLACEHOLDER": "Domena, na której otrzymujesz wiadomości e-mail",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "E-mail obsługi",
        "PLACEHOLDER": "E-mail obsługi klienta Twojej firmy",
        "ERROR": ""
      },
      "AUTO_RESOLVE_IGNORE_WAITING": {
        "LABEL": "Exclude unattended conversations",
        "HELP": "When enabled, the system will skip resolving conversations that are still waiting for an agent's reply."
      },
      "AUDIO_TRANSCRIPTION": {
        "TITLE": "Transcribe Audio Messages",
        "NOTE": "Automatically transcribe audio messages in conversations. Generate a text transcript whenever an audio message is sent or received, and display it alongside the message.",
        "API": {
          "SUCCESS": "Audio transcription setting updated successfully",
          "ERROR": "Failed to update audio transcription setting"
        }
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Inactivity duration for resolution",
        "HELP": "Duration after a conversation should auto resolve if there is no activity",
        "PLACEHOLDER": "30",
        "ERROR": "Auto resolve duration should be between 10 minutes and 999 days",
        "API": {
          "SUCCESS": "Auto resolve settings updated successfully",
          "ERROR": "Failed to update auto resolve settings"
        },
        "UPDATE_BUTTON": "Aktualizuj",
        "MESSAGE_LABEL": "Custom resolution message",
        "MESSAGE_PLACEHOLDER": "Conversation was marked resolved by system due to 15 days of inactivity",
        "MESSAGE_HELP": "This message is sent to the customer when a conversation is automatically resolved by the system due to inactivity."
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "Kontynuacja rozmów za pomocą wiadomości e-mail jest włączona dla Twojego konta.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Możesz teraz odbierać wiadomości e-mail na swojej własnej domenie."
      }
    },
    "UPDATE_CHATWOOT": "Dostępna jest aktualizacja do wersji {latestChatwootVersion} Chatwoot. Proszę zaktualizować swoją instancję.",
    "LEARN_MORE": "Dowiedz się więcej",
    "PAYMENT_PENDING": "Twoja płatność jest w toku. Zaktualizuj informacje o płatności, aby kontynuować korzystanie z Chatwoot.",
    "UPGRADE": "Upgrade to continue using Chatwoot",
    "LIMITS_UPGRADE": "Twoje konto przekroczyło limit użytkowania. Zaktualizuj swój plan, aby kontynuować korzystanie z Chatwoot.",
    "OPEN_BILLING": "Otwórz fakturę"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Naciśnij Enter, aby wybrać",
      "ENTER_TO_REMOVE": "Naciśnij Enter, aby usunąć",
      "NO_OPTIONS": "List is empty",
      "SELECT_ONE": "Wybierz jeden",
      "SELECT": "Wybierz"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Powiadomienia",
    "MARK_ALL_DONE": "Oznacz wszystkie jako zrobione",
    "DELETE_TITLE": "usunięto",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Nieprzeczytane powiadomienia",
      "ALL_NOTIFICATIONS": "Wyświetl wszystkie powiadomienia",
      "LOADING_UNREAD_MESSAGE": "Ładowanie nieprzeczytanych powiadomień...",
      "EMPTY_MESSAGE": "Nie masz żadnych nieprzeczytanych powiadomień"
    },
    "LIST": {
      "LOADING_MESSAGE": "Ładowanie powiadomień...",
      "404": "Nie znaleziono powiadomień",
      "TABLE_HEADER": [
        "Nazwisko",
        "Numer telefonu",
        "Rozmowy",
        "Ostatni kontakt"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Nowa rozmowa",
      "conversation_assignment": "Przypisanie rozmowy",
      "assigned_conversation_new_message": "Nowa wiadomość",
      "participating_conversation_new_message": "Nowa wiadomość",
      "conversation_mention": "Wzmianka",
      "sla_missed_first_response": "SLA Missed",
      "sla_missed_next_response": "SLA Missed",
      "sla_missed_resolution": "SLA Missed"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Niedostępny",
      "RECONNECTING": "Reconnecting...",
      "RECONNECT_SUCCESS": "Reconnected"
    },
    "BUTTON": {
      "REFRESH": "Odśwież"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Szukaj lub przejdź do",
    "SNOOZE_PLACEHOLDER": "Type a time e.g. tomorrow, 2 hours, next friday, jan 15...",
    "SECTIONS": {
      "GENERAL": "Ogólne",
      "REPORTS": "Raporty",
      "CONVERSATION": "Rozmowa",
      "BULK_ACTIONS": "Bulk Actions",
      "CHANGE_ASSIGNEE": "Zmień przypisanego",
      "CHANGE_PRIORITY": "Zmień priorytet",
      "CHANGE_TEAM": "Zmień zespół",
      "SNOOZE_CONVERSATION": "Zatrzymaj rozmowę",
      "ADD_LABEL": "Dodaj etykietę do rozmowy",
      "REMOVE_LABEL": "Usuń etykietę z rozmowy",
      "SETTINGS": "Ustawienia",
      "AI_ASSIST": "AI Assist",
      "APPEARANCE": "Appearance",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Przejdź do pulpitu rozmów",
      "GO_TO_CONTACTS_DASHBOARD": "Przejdź do pulpitu kontaktów",
      "GO_TO_REPORTS_OVERVIEW": "Przejdź do przeglądu raportów",
      "GO_TO_CONVERSATION_REPORTS": "Przejdź do raportów rozmów",
      "GO_TO_AGENT_REPORTS": "Przejdź do raportów agentów",
      "GO_TO_LABEL_REPORTS": "Przejdź do raportów etykiet",
      "GO_TO_INBOX_REPORTS": "Przejdź do raportów skrzynek odbiorczych",
      "GO_TO_TEAM_REPORTS": "Przejdź do raportów zespołów",
      "GO_TO_SETTINGS_AGENTS": "Przejdź do ustawień agentów",
      "GO_TO_SETTINGS_TEAMS": "Przejdź do ustawień zespołów",
      "GO_TO_SETTINGS_INBOXES": "Przejdź do ustawień skrzynek odbiorczych",
      "GO_TO_SETTINGS_LABELS": "Przejdź do ustawień etykiet",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Przejdź do ustawień gotowych odpowiedzi",
      "GO_TO_SETTINGS_APPLICATIONS": "Przejdź do ustawień aplikacji",
      "GO_TO_SETTINGS_ACCOUNT": "Przejdź do ustawień konta",
      "GO_TO_SETTINGS_PROFILE": "Przejdź do ustawień profilu",
      "GO_TO_NOTIFICATIONS": "Przejdź do powiadomień",
      "ADD_LABELS_TO_CONVERSATION": "Dodaj etykietę do rozmowy",
      "ASSIGN_AN_AGENT": "Przypisz agenta",
      "AI_ASSIST": "AI Assist",
      "ASSIGN_PRIORITY": "Przypisz priorytet",
      "ASSIGN_A_TEAM": "Przypisz zespół",
      "MUTE_CONVERSATION": "Wycisz rozmowę",
      "UNMUTE_CONVERSATION": "Wyłącz wyciszenie rozmowy",
      "REMOVE_LABEL_FROM_CONVERSATION": "Usuń etykietę z rozmowy",
      "REOPEN_CONVERSATION": "Ponownie otwórz rozmowę",
      "RESOLVE_CONVERSATION": "Zamknij rozmowę",
      "SEND_TRANSCRIPT": "Wyślij transkrypt rozmowy",
      "SNOOZE_CONVERSATION": "Zatrzymaj rozmowę",
      "UNTIL_NEXT_REPLY": "Do następnej odpowiedzi",
      "UNTIL_NEXT_WEEK": "Do następnego tygodnia",
      "UNTIL_TOMORROW": "Do jutra",
      "UNTIL_NEXT_MONTH": "Do następnego miesiąca",
      "AN_HOUR_FROM_NOW": "Do godziny od teraz",
      "UNTIL_CUSTOM_TIME": "Niestandardowe...",
      "CHANGE_APPEARANCE": "Change Appearance",
      "LIGHT_MODE": "Light",
      "DARK_MODE": "Dark",
      "SYSTEM_MODE": "System",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Ładowanie aplikacji pulpitu..."
  },
  "COMMON": {
    "OR": "Or",
    "CLICK_HERE": "kliknij tutaj"
  }
}
